/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MeQueryVariables = Types.Exact<{
  orgIdOverride: Types.InputMaybe<Types.Scalars["OrgId"]["input"]>;
}>;

export type MeQuery = {
  readonly __typename: "Query";
  readonly launchDarklyContext: unknown;
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
    readonly imageUrl: string | null;
    readonly orgRole: Types.OrgRole;
    readonly canViewCategoriesOrStatus: boolean;
    readonly persona: c.Persona | null;
    readonly emailVerified: boolean;
    readonly platformRole: Types.PlatformRole;
    readonly createdDate: c.DateTimeString;
    readonly isSelfServe: boolean;
    readonly vimMode: boolean;
    readonly confirmedPaidCompute: boolean;
    readonly stackId: string;
    readonly hasApiAccess: boolean;
    readonly interactions: c.PartialUserInteractions;
    readonly firstLoginFeatureFlags: c.PartialNewUserFeatureSet;
    readonly pylonEmailHash: string | null;
    readonly userAttributes: c.UserAttributes | null;
    readonly userSettings: c.PartialUserSettings;
  } | null;
  readonly myOrg: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly displayName: string;
    readonly createdDate: c.DateTimeString;
    readonly featureGateSet: c.FeatureGateSet;
    readonly supportUserId: c.UserId | null;
    readonly isSignupComplete: boolean;
    readonly allowFileUploads: boolean;
    readonly featureGateTier: Types.FeatureGateTier;
    readonly featureGateUpgradeToTier: c.FeatureGateUpgradeToTierMapping;
    readonly signedEmbeddingEnabled: boolean;
    readonly allowParameterizedLinkSharing: boolean;
    readonly hasConnectionWithDbtSemanticLayer: boolean;
    readonly explorerEnabled: boolean;
    readonly supportChatEnabled: boolean;
    readonly canViewAgentStats: boolean;
    readonly canViewAgentTopics: boolean;
    readonly canViewSuggestions: boolean;
    readonly canViewOrgEvals: boolean;
    readonly canEditVcsConnections: boolean;
    readonly canViewMcpServerConfigurations: boolean;
    readonly canManageMcpServerConfigurations: boolean;
  } | null;
};

export type MeOrgFragment = {
  readonly __typename: "Org";
  readonly id: c.OrgId;
  readonly displayName: string;
  readonly createdDate: c.DateTimeString;
  readonly featureGateSet: c.FeatureGateSet;
  readonly supportUserId: c.UserId | null;
  readonly isSignupComplete: boolean;
  readonly allowFileUploads: boolean;
  readonly featureGateTier: Types.FeatureGateTier;
  readonly featureGateUpgradeToTier: c.FeatureGateUpgradeToTierMapping;
  readonly signedEmbeddingEnabled: boolean;
  readonly allowParameterizedLinkSharing: boolean;
  readonly hasConnectionWithDbtSemanticLayer: boolean;
  readonly explorerEnabled: boolean;
  readonly supportChatEnabled: boolean;
  readonly canViewAgentStats: boolean;
  readonly canViewAgentTopics: boolean;
  readonly canViewSuggestions: boolean;
  readonly canViewOrgEvals: boolean;
  readonly canEditVcsConnections: boolean;
  readonly canViewMcpServerConfigurations: boolean;
  readonly canManageMcpServerConfigurations: boolean;
};

export type UpdateLastSeenDateMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UpdateLastSeenDateMutation = {
  readonly __typename: "Mutation";
  readonly updateLastSeenDate: string;
};

export const MeOrgFragmentDoc = /*#__PURE__*/ gql`
  fragment MeOrgFragment on Org {
    id
    displayName
    createdDate
    featureGateSet
    supportUserId
    isSignupComplete
    allowFileUploads
    featureGateTier
    featureGateUpgradeToTier
    signedEmbeddingEnabled
    allowParameterizedLinkSharing
    hasConnectionWithDbtSemanticLayer
    explorerEnabled
    supportChatEnabled
    canViewAgentStats
    canViewAgentTopics
    canViewSuggestions
    canViewOrgEvals
    canEditVcsConnections
    canViewMcpServerConfigurations
    canManageMcpServerConfigurations
  }
`;
export const MeDocument = /*#__PURE__*/ gql`
  query Me($orgIdOverride: OrgId) {
    me {
      id
      name
      email
      imageUrl
      orgRole
      canViewCategoriesOrStatus
      persona
      emailVerified
      platformRole
      createdDate
      isSelfServe
      vimMode
      confirmedPaidCompute
      stackId
      hasApiAccess
      interactions
      firstLoginFeatureFlags
      pylonEmailHash
      userAttributes
      userSettings
    }
    myOrg {
      id
      ...MeOrgFragment
    }
    launchDarklyContext(orgIdOverride: $orgIdOverride)
  }
  ${MeOrgFragmentDoc}
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      orgIdOverride: // value for 'orgIdOverride'
 *   },
 * });
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(
    MeDocument,
    options,
  );
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateLastSeenDateDocument = /*#__PURE__*/ gql`
  mutation UpdateLastSeenDate {
    updateLastSeenDate
  }
`;
export type UpdateLastSeenDateMutationFn = Apollo.MutationFunction<
  UpdateLastSeenDateMutation,
  UpdateLastSeenDateMutationVariables
>;

/**
 * __useUpdateLastSeenDateMutation__
 *
 * To run a mutation, you first call `useUpdateLastSeenDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastSeenDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastSeenDateMutation, { data, loading, error }] = useUpdateLastSeenDateMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLastSeenDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLastSeenDateMutation,
    UpdateLastSeenDateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLastSeenDateMutation,
    UpdateLastSeenDateMutationVariables
  >(UpdateLastSeenDateDocument, options);
}
export type UpdateLastSeenDateMutationHookResult = ReturnType<
  typeof useUpdateLastSeenDateMutation
>;
export type UpdateLastSeenDateMutationResult =
  Apollo.MutationResult<UpdateLastSeenDateMutation>;
export type UpdateLastSeenDateMutationOptions = Apollo.BaseMutationOptions<
  UpdateLastSeenDateMutation,
  UpdateLastSeenDateMutationVariables
>;
